.root {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.moneyInteger {
  font-size: 1.4rem;
}
